import './resources/App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidenav from './components/Sidenav';
import Header from './components/Header';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Posts from './components/Posts';
import Contact from './components/Contact';
import Education from './components/Education';
import Certifications from './components/Certifications';
import Awards from './components/Awards';

function ProfilePage() {
  return (
    <div>
      <Header />
      <Skills />
      <Certifications />
      <Awards />
      <Experience />
      <Projects />
      <Education />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App app-flex">
        <Sidenav />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<ProfilePage />} />
            <Route path="/posts" element={<Posts />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
